import { compact } from 'lodash-es';
import { isTalosWLDemoEnv } from '../../utils';
import type { LocaleItem } from './types';

export const supportedLocales: LocaleItem[] = compact([
  {
    displayName: 'English',
    flag: '🇺🇸',
    value: 'en',
  },
  {
    displayName: 'Deutsch',
    flag: '🇩🇪',
    value: 'de',
  },
  {
    displayName: 'French',
    flag: '🇫🇷',
    value: 'fr',
  },
  {
    displayName: 'Spanish',
    flag: '🇪🇸',
    value: 'es',
  },
  {
    displayName: 'Italian',
    flag: '🇮🇹',
    value: 'it',
  },
  {
    displayName: 'Polish',
    flag: '🇵🇱',
    value: 'pl',
  },
  isTalosWLDemoEnv
    ? {
        displayName: 'Testing',
        flag: '✅',
        value: 'testing',
      }
    : null,
]);
